module.exports = __webpack_public_path__ + "img/112.92adf67a.png";